module.exports = __webpack_public_path__ + "img/y-69.261b9eba.png";